export namespace GraphActions {
    export class Clear {
        static readonly type = 'GraphActions.Clear';
    }

    export class ClearGeneralContractList {
        static readonly type = 'GraphActions.ClearGeneralContractList';
    }

    export class SearchGeneralContracts {
        static readonly type = 'GraphActions.SearchGeneralContracts';

        constructor(public phrase: string) {}
    }

    export class GetSales {
        static readonly type = 'GraphActions.GetSales';

        constructor(public filters: any) {}
    }
}
